import { rokidMetisBaseUrl } from "@rokid/host";
import { requestSSE, type IRequest } from "@rokid/utils";
import type { IGetOptimizedPromptReq } from "./prompt.d";

/**
 * 获取优化的提示词
 */
export const getOptimizedPrompt = (obj: {
  data: IGetOptimizedPromptReq;
  onStart?: () => void;
  onMessage?: (data: string) => void;
  onEnd?: () => void;
}) => {
  const { data, onStart, onMessage, onEnd } = obj;  
  requestSSE({
    url: `${rokidMetisBaseUrl}/agent/api/sse`,
    method: "post",
    data,
    onMessage,
    onStart,
    onEnd,
    needToken: true,
  });
};
